// extracted by mini-css-extract-plugin
export default {"ticketsStatusContent":"TicketsStatus_ticketsStatusContent__FNxPV","info":"TicketsStatus_info__LIsTs","dot":"TicketsStatus_dot__Ue67H"};